// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1687 ? "b9eaa7a1" : chunkId) + "." + {"795":"44d706db512a8596","812":"646660e57dab1108","1687":"297e42e1b498c2bc","2361":"1abe5b0915246bca","6444":"c7acba6beb30f46f","7226":"ba80ebe1f328de21","7788":"52d2f0665973ce2e","8685":"00060cb400388641"}[chunkId] + ".js";
};